<template>
  <div>
    <my-loader v-if="isLoading" />

    <div v-else-if="hasError" class="state-block">
      Не удалось загрузить заказчика.
      <div class="state-actions">
        <BackButton />
      </div>
    </div>

    <div v-else-if="customer" class="content">
      <div class="upload-btn">
        <BackButton class="back-btn-customer" />
        <DriverBlackList :customerId="customer.id" />
        <CustomerMatrix :customerId="customer.id" />
      </div>
      <div class="liner" />
      <CustomerInfo
        :customer="customer"
        :saving="saving"
        @updateCustomer="updateCustomer"
      />
    </div>

    <div v-else class="state-block">
      Нет данных.
      <div class="state-actions">
        <BackButton />
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from 'vuex'
import { computed, onMounted, ref, watch } from 'vue'
import CustomerInfo from '@/pages/customer/components/CustomerInfo'
import DriverBlackList from '@/pages/customer/components/DriverBlackList'
import CustomerMatrix from '@/pages/customer/components/CustomerMatrix'
import { useRoute } from 'vue-router'
import { shouldShowCustomerDetailLoader } from '@/pages/customer/customerState.mjs'

export default {
  name: 'CustomerDetail',
  components: {
    CustomerInfo,
    DriverBlackList,
    CustomerMatrix,
  },
  setup() {
    const store = useStore()
    const route = useRoute()
    const hasError = ref(false)
    const saving = ref(false)

    const loadCustomer = async (id) => {
      hasError.value = false
      const ok = await store.dispatch('apiStorage/getItem', {
        model: 'customers',
        params: { id },
      })
      hasError.value = !ok
    }

    onMounted(() => {
      loadCustomer(route.params.id)
    })

    watch(
      () => route.params.id,
      (id) => {
        if (id) loadCustomer(id)
      },
    )

    const updateCustomer = async (form) => {
      saving.value = true
      try {
        await store.dispatch('apiStorage/updateItem', {
          model: 'customers',
          form,
        })
      } finally {
        saving.value = false
      }
    }

    return {
      updateCustomer,
      hasError,
      saving,
      isLoading: computed(() =>
        shouldShowCustomerDetailLoader({
          statusLoading: store.state.apiStorage.customers.statusLoading,
          saving: saving.value,
        }),
      ),
      customer: computed(() => store.state.apiStorage.customers.item),
    }
  },
}
</script>

<style scoped>
.upload-btn {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.back-btn-customer {
  margin-left: 20px;
}

.state-block {
  padding: 32px;
  color: #667085;
  text-align: center;
}

.state-actions {
  margin-top: 16px;
  display: flex;
  justify-content: center;
}
</style>
